import React from "react";
import {fb} from "../../firebase";
import "./Events.scss";


class Events extends React.Component {
  constructor(props) {
    super(props);
    this.ref = fb.firestore().collection("fl_content");
    this.unsubscribe = null;
    this.state = {
      infoleiste: [],
      open: false,
    };
  }
  onCollectionUpdate = (querySnapshot) => {
    const infoleiste = [];
    querySnapshot.forEach((doc) => {
      var schema;

      if (doc.data()._fl_meta_.schema === "infoleiste") {
        schema = doc.data()._fl_meta_.schema;
        const {
          infoText,
          infoColor,
          infoBackgroundColor,
          infoLink,
          order,
        } = doc.data();
        infoleiste.push({
          key: doc.id,
          schema,
          infoText,
          infoLink,
          infoColor,
          infoBackgroundColor,
          order,
        });
      }
    });
    // this.setState({
    //   infoleiste,
    // });


    this.setState( (prevState) => {

      return {
        ...prevState,
        infoleiste: infoleiste.sort(function (a, b) {
          if (a.order > b.order) {
            return 1;
          } else if (a.order < b.order) {
            return -1;
          } else {
            return 0;
          }
        })
      }

    })


  };
  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);


  }
  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    return (
      <>
        <div className="event_page_wrapper">
          <div className="event_header">
            <h1>
              <span>/ </span>
              Eventplan
            </h1>
          </div>
          <div className="event_list_wrapper">
            {this.state.infoleiste.map((index, i) => {
              return (
                <a className="event_container" href={index.infoLink} key={i} target="_blank">
                  <div>
                    <span>{index.infoText}</span>
                  </div>
                </a>
              );
            })}
            </div>
        </div>
      </>
    );
  }
}

export default Events;
